<template>
  <v-card class="card--shadow">
    <v-card-title>Visit Date</v-card-title>
    <v-card-text>
      <date-generate-from @generateDate="generateDate" />
    </v-card-text>
    <v-card-text>
      <date-table-view :dates="dates" />
    </v-card-text>
  </v-card>
</template>

<script>
import DateGenerateFrom from "./UseApp/DateGenerateForm.vue";
import DateTableView from "./UseApp/DateTableView.vue";
import { generateDate } from "./helper";

export default {
  data: () => ({
    dates: [],
  }),
  components: {
    DateGenerateFrom,
    DateTableView,
  },
  methods: {
    generateDate(data) {
      this.$store
        .dispatch("DotsPatient/getVisitDate", {
          dots_patient_id: this.$route.params.id,
        })
        .then((res) => {
          this.dates = generateDate(data.startDate, data.endDate);
          this.dates = this.generateResult(this.dates, res);
          console.log(this.dates);
        });
    },
    generateResult(dates, res) {
      dates = dates.map((date) => {
        res.forEach((foundDate) => {
          if (foundDate.date == date.date) {
            date.found = true;
            date.data = foundDate;
          }
        });
        return date;
      });

      return dates;
    },
  },
};
</script>

<style></style>
